import { render, staticRenderFns } from "./createPNG.dialog.vue?vue&type=template&id=6326524e&scoped=true"
import script from "./createPNG.dialog.vue?vue&type=script&lang=js"
export * from "./createPNG.dialog.vue?vue&type=script&lang=js"
import style0 from "./createPNG.dialog.vue?vue&type=style&index=0&id=6326524e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6326524e",
  null
  
)

export default component.exports